export const EMPTY_CART_SUCCESS_TOAST_ID = "empty-cart-success";
export const CART_UPDATED_TOAST_ID = "cart-updated";
export const ITEM_UPDATE_SUCCESS_TOAST_ID = "add-item-success";
export const ITEM_REMOVE_SUCCESS_TOAST_ID = "remove-item-success";

export const PAYMENT_ERROR_TOAST_ID = "payment-error";
export const PAYMENT_CARD_INTENT_ERROR_TOAST_ID = "payment-card-intent-error";
export const STRIPE_ERROR_TOAST_ID = "stripe-error";

export const UPDATE_ORDER_ERROR_TOAST_ID = "update-order-error";
export const SAVE_GIFT_ACKNOWLEDGEMENT_ERROR_TOAST_ID = "save-gift-acknowledgement-error";
export const CANCEL_ORDER_ERROR_TOAST_ID = "cancel-order-error";

export const RLP_USER_INFO_ERROR_TOAST_ID = "rlp-user-info-error";
